import { DiagramComponent } from '../../core/DiagramComponent';
import type { CircleConfig, Variables, JXGBoard, JXGElement } from '../../types/interfaces';

interface ExtendedCircleConfig extends CircleConfig {
  width?: number;
  attributes?: Record<string, any>;
}

/**
 * Circle component
 */
export class Circle extends DiagramComponent<ExtendedCircleConfig> {
  constructor(config: ExtendedCircleConfig, board: JXGBoard, parentState: Variables = {}) {
    super(config, board, parentState);
  }

  render(): JXGElement {
    const config = this.config;
    const center = config.center || [0, 0];
    const radius = this.evaluateExpression(config.radius || 1);

    const cx = this.evaluateExpression(center[0]);
    const cy = this.evaluateExpression(center[1]);

    const attributes = {
      strokeColor: config.color || '#000',
      strokeWidth: config.width || 2,
      fillColor: config.fillColor || 'none',
      fillOpacity: config.fillOpacity || 0.3,
      ...config.attributes,
    };

    const circle = this.board.create('circle', [[cx, cy], radius], attributes);
    this.jsxElements.push(circle);

    return circle;
  }

  getSpecificity(): number {
    // Specificity inversely proportional to area
    const radius = this.evaluateExpression(this.config.radius || 1);
    const numRadius = typeof radius === 'number' ? radius : parseFloat(String(radius)) || 1;
    const area = Math.PI * numRadius * numRadius;
    return Math.max(10, 100 - area); // Smaller circles = higher priority
  }
}
